import { useMutation } from "react-query";

import { VerifyDirectLoginResponse } from "./types";
/**
 * Verify direct login for Japan market
 */
async function verifyDirectLogin(queryParameter: string) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/verify-direct`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "*/*",
      },
      body: JSON.stringify({
        queryParameter,
      }),
    },
  );

  if (!response.ok) throw new Error("Network response was not ok");

  return response.json() as Promise<VerifyDirectLoginResponse>;
}

export default function useVerifyDirectLogin() {
  return useMutation({
    mutationFn: verifyDirectLogin,
  });
}
